import React from "react";
import ReactDOM from "react-dom";
import styles from "../../styles/GenericModal.module.scss";

const GenericModal = ({
  isShowing,
  hide,
  children,
  hideClose,
  modalStyle,
  darkMode,
  modalHeaderStyle,
  type = "DEFAULT",
}) => {
  return isShowing
    ? ReactDOM.createPortal(
        <>
          <div className={styles.modalOverlay}> </div>
          <div
            className={styles.modalWrapper}
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className={styles.modal} style={modalStyle}>
              <div className={styles.modalHeader} style={modalHeaderStyle}>
                { type === "SUCCESS" && <><img
                  alt="type-icon"
                  src={"https://frontend-assets.buildbox.com/check.png"}
                />
                <h1>Success</h1></> }
                {/* /* 
                        TODO: make modal as reusable as possible? */}
                {!hideClose && (
                  <button
                    type="button"
                    className={styles.closeButton}
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={hide}
                  >
                    {/* <img
                      alt="close"
                      src={
                        darkMode
                          ? "https://frontend-assets.buildbox.com/X.svg"
                          : "https://frontend-assets.buildbox.com/x.png"
                      }
                    /> */}
                    {/* X icon */}
                    <span
                      aria-hidden="true"
                      className={
                        darkMode ? styles.lightButton : styles.darkButton
                      }
                    >
                      &times;
                    </span>
                  </button>
                )}
              </div>
              <div className={styles.modalBody}>{children}</div>
            </div>
          </div>
        </>,
        document.body
      )
    : null;
};

export default GenericModal;
